import { render } from "./Bookingservices.vue?vue&type=template&id=0c06c4ce&scoped=true"
import script from "./Bookingservices.vue?vue&type=script&lang=js"
export * from "./Bookingservices.vue?vue&type=script&lang=js"

import "./Bookingservices.vue?vue&type=style&index=0&id=0c06c4ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c06c4ce"]])

export default __exports__